<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div
    class="giga-input_field "
    :class="[
      variable.emmy.value.$anyDirty && variable.emmy.value.$invalid
        ? 'field-hasError'
        : '',
      !variable.emmy.value.required ? 'field-isRequired' : ''
    ]"
  >
    <label class="input-field_label" :for="'condition'">{{
      variable.emmy.name.$model
    }}
      <span class="text-danger">*</span>
    </label>
    <div
      v-if="
        (variable.emmy.type.$model === 'LIST' && !variable.enterable.$model) ||
          variable.emmy.type.$model === 'CLIMATIC_ZONE'
      "
      class="input-field_area"
    >
      <select
        :id="'select-variable-' + variable.emmy.value.$model"
        v-model="variable.emmy.value.$model"
        :disabled="variable.emmy.type.$model === 'CLIMATIC_ZONE' || isVIEWER"
        class="small-input"
      >
        <option
          v-for="option of variable.emmy.listConditions.$model"
          :key="option.libelle + ficheIndex"
          :value="option.value"
          >{{ option.libelle }}</option
        >
      </select>
      <div
        class="validation-field-holder"
        v-if="variable.emmy.value.$anyDirty && variable.emmy.value.$invalid"
      >
        <small
          class="form-text text-danger"
          v-if="!variable.emmy.value.required"
        >
          {{ $t("required_field") }}
        </small>
      </div>
    </div>

    <div v-else class="input-field_area">
      <input
        :id="'input-variable-' + variable.emmy.id.$model"
        :type="mapVarType()"
        v-model="variable.emmy.value.$model"
        class="small-input"
        :disabled="isVIEWER"
      />
      <div
        class="validation-field-holder"
        v-if="variable.emmy.value.$anyDirty && variable.emmy.value.$invalid"
      >
        <small v-if="!variable.emmy.value.required">
          {{ $t("required_field") }}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FicheVariable",
  props: ["variable", "climateZone", "ficheIndex", "isVIEWER"],
  components: {},
  data() {
    return {};
  },
  mounted() {
    this.initVariableIfClimateZoneOrWithOneCondition();
  },
  methods: {
    mapVarType() {
      if (
        this.variable.emmy.type.$model === "INTEGER" ||
        this.variable.emmy.type.$model === "FLOAT" ||
        (this.variable.emmy.type.$model === "LIST" &&
          this.variable.enterable.$model)
      ) {
        return "number";
      }
      // case: this.variable.emmy.type.$model === 'TEXT'
      else {
        return "text";
      }
    },
    initVariableIfClimateZoneOrWithOneCondition() {
      if (this.variable.emmy.type.$model === "CLIMATIC_ZONE") {
        this.variable.emmy.value.$model = this.variable.emmy.$model.listConditions.find(
          condition => condition.libelle === this.climateZone
        ).value;
      } else if (
        this.variable.emmy.type.$model === "LIST" &&
        !this.variable.enterable.$model &&
        this.variable.emmy.$model.listConditions.length === 1
      ) {
        this.variable.emmy.value.$model = this.variable.emmy.$model.listConditions[0].value;
      } else {
        // do nothing
      }
    }
  },
  watch: {
    climateZone: function() {
      this.initVariableIfClimateZoneOrWithOneCondition();
    }
  }
};
</script>

<style lang="scss"></style>
